var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "facebook_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#facebook_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M34.165 19.652c0-8.057-6.492-14.588-14.5-14.588s-14.5 6.531-14.5 14.588c0 7.282 5.302 13.317 12.234 14.412V23.869h-3.681v-4.217h3.681v-3.214c0-3.656 2.165-5.675 5.477-5.675 1.587 0 3.246.284 3.246.284v3.59h-1.828c-1.802 0-2.363 1.125-2.363 2.279v2.736h4.021l-.643 4.217h-3.378v10.195c6.932-1.095 12.234-7.13 12.234-14.412Z"
}))));
export default SvgFacebook;